import axios from "axios";
const baseurl = process.env.REACT_APP_API_URL;

export const searchProducts = async (productsSearch) => {
  const res = await axios({
    method: "get",
    url: baseurl + `/searchProducts?query=${productsSearch}`,
  });
  return res.data.data;
};
